import { Avatar } from "@maxhub/max-ui"
import { PlaceholderIcon } from "../shared/PlaceholderIcon"

export const AvatarIconExample = {
    title: 'Avatar.Icon',
    defaultPlatform: 'ios',
    defaultZoom: 100,

    controls: [],

    Preview({ props }){
        return (
            <Avatar.Container>
                <Avatar.Icon>
                    <PlaceholderIcon />
                </Avatar.Icon>
            </Avatar.Container>
        )
    },

    getCode(){
        return `<Avatar.Container>
  <Avatar.Icon>
    <Icon24Placeholder />
  </Avatar.Icon>
</Avatar.Container>`
    }

}